import { Toaster as SileoToaster } from "sileo"
import "./sileo-theme.css"

const Toaster = () => {
  return (
    <SileoToaster
      position="top-center"
      options={{
        duration: 4000,
        roundness: 14,
        fill: "#0a0a0a",
        autopilot: {
          expand: 600,
          collapse: 3000,
        },
        styles: {
          title: "!text-white !text-[13px] !font-bold !tracking-wide",
          description: "!text-gray-400 !text-xs",
          badge: "!bg-white/10",
          button: "!bg-white/10 !text-white !text-xs",
        },
      }}
    />
  )
}

export { Toaster }
